module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ee-Fb-Gb.8b4c7a59.png";